<template>
	<div class="content-wrap">
    <el-form :inline="true">
      <el-form-item label="违规记录ID号">
        <el-input v-model.number="blacklistId" placeholder="违规记录ID号" clearable></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="platform" placeholder="请选择" clearable>
          <el-option key="QualityControl" label="质检平台" value="QualityControl"></el-option>
          <el-option key="Forewarning" label="预警平台" value="Forewarning"></el-option>
          <el-option key="CommonRule" label="通用规则" value="CommonRule"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="compositeState" placeholder="请选择" clearable>
          <el-option key="Punished" label="已扣罚" value="Punished"></el-option>
          <el-option key="Appealable" label="有疑议可申诉" value="Appealable"></el-option>
          <el-option key="Appealing" label="申诉中" value="Appealing"></el-option>
          <el-option key="AppealSuccess" label="申诉成功" value="AppealSuccess"></el-option>
          <el-option key="AppealFail" label="申诉失败" value="AppealFail"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border highlight-current-row style="width: 100%">
      <el-table-column prop="blacklistId" label="违规记录ID" align="center"></el-table-column>
      <el-table-column prop="compositeStateValue" label="状态" align="center"></el-table-column>
      <el-table-column prop="createTime" label="日期" align="center"></el-table-column>
      <el-table-column prop="platformName" label="类型" align="center"></el-table-column>
      <el-table-column prop="shopName" label="关联店铺" align="center"></el-table-column>
      <el-table-column prop="platformRuleContent" label="违反规章" align="center"></el-table-column>
      <el-table-column prop="punishContent" label="处罚内容" align="center"></el-table-column>
      <el-table-column prop="remark" label="具体原因" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
        	<template v-if="scope.row.platform == 'QualityControl' && scope.row.thirdPlatformId.indexOf('offline_') < 0">
        		<a href="javascript:;" class="link-text" @click="jumpToInfo(scope.row)">查看详情</a>
        	</template>
          <template v-else>
          	<span class="link-text" v-if="scope.row.compositeState == 'Appealing' || scope.row.compositeState == 'AppealSuccess' || scope.row.compositeState == 'AppealFail'" @click="showResultModal(scope.row.blacklistId)">查看详情</span>
          	<span class="link-text" v-if="scope.row.compositeState == 'Appealable' && 'QualityControl' !== scope.row.platform" @click="showModal(scope.row.blacklistId)">申诉</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <pagination :pages="pages" :pageNum="pageNum" @getData="getList"></pagination>
    <!--申诉-->
    <el-dialog title="申诉原因" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <el-form :model="modal" ref="modal" :rules="rules" label-width="120px">
        <el-form-item label="上传图片" class="is-required">
          <el-upload action="//upload-z0.qiniup.com" list-type="picture-card" :on-remove="handleRemove" :data="token" :before-upload="getToken" :on-success="uploadSuccess" :file-list="fileList">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="原因" prop="appealExplain">
          <el-input v-model="modal.appealExplain" type="textarea" autosize placeholder="请控制在500个字内" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="addModalFun">确 定</el-button>
      </span>
    </el-dialog>
    <!--查看结果-->
    <el-dialog title="申诉原因" :visible.sync="dialogVisibleResult" width="50%" :before-close="handleCloseResult">
      <el-form label-width="120px">
        <el-form-item label="图片：">
          <template v-for="(item, key) in result.appealExtend">
          	<img :src="item" class="form-img" />
          </template>
        </el-form-item>
        <el-form-item label="原因：">
          {{ result.appealExplain }}
        </el-form-item>
        <el-form-item label="结果：">
          <template v-if="result.handleState == 'Appealing'">申诉中</template>
          <template v-if="result.handleState == 'AppealSuccess'">申诉成功</template>
          <template v-if="result.handleState == 'AppealUnSuccess'">申诉失败</template>
        </el-form-item>
        <el-form-item>
          {{ result.handleExplain }}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseResult">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				dialogVisibleResult: false,
				pageNum: 1,
				pageSize: 10,
				pages: 1,
				blacklistId: '',
				platform: '',
				compositeState: '',
				list: [],
				fileList: [], //已上传凭证列表
	      token: null,
	      uploaderDomain: null,
	      modal: {
	      	punishId: '',
	      	appealExtend: [],
	      	appealExplain: ''
	      },
	      result: {},
	      rules: {
	        appealExplain: [
	          { required: true, message: '请输入申诉原因', trigger: 'blur' },
	          { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
	        ]
	      }
			}
		},
		mounted() {
			this.getList(1)
		},
		methods: {
			getList(num) {
				var data = {
					'pageNum': num,
        	'pageSize': this.pageSize,
        	'blacklistId': this.blacklistId,
        	'platform': this.platform,
        	'compositeState': this.compositeState
				}
				this.$http.post(API_ROOT.method + '/blacklist/queryPersonalBlacklist', data).then(response => {
	        var result = response.data
	        if(result.success) {
	          this.pages = result.data.pages
						this.pageNum = result.data.pageNum
						this.list = result.data.list
	        }else {
	          this.$alert(result.msg)
	        }
	      }, response => {
	        this.$alert('网络繁忙，请稍后重试！')
	      })
			},
			//弹出层显示
			showModal(blacklistId) {
				this.dialogVisible = true
				this.modal.punishId = blacklistId
			},
			//弹出层关闭
	    handleClose() {
	      this.$refs['modal'].resetFields()
	      this.dialogVisible = false
	      this.modal.appealExtend = []
	      this.fileList = []
	    },
	    //申诉提交
	    addModalFun() {
	      var self = this
	      this.$refs.modal.validate((valid) => {
	        if(valid) {
	        	if(self.modal.appealExtend.length == 0) {
	        		self.$alert('请上传图片')
	        		return
	        	}
	          self.$http.post(API_ROOT.method + '/appeal/instituteAppeal', self.modal).then(response => {
	            var result = response.data
	            if(result.success) {
	              self.$message({
	                message: '已提交',
	                type: 'success',
	                center: true,
	                duration: 1000
	              })
	              self.handleClose()
	              self.getList(self.pageNum)
	            }else {
	              self.$alert(result.message)
	            }
	          }, response => {
	            self.$alert('网络繁忙，请稍后重试！')
	          })
	        }else {
	          return false
	        }
	      })
	    },
	    handleRemove(file, fileList) {
	      this.modal.appealExtend = []
	      this.fileList = []
	      fileList.map((item)=> {
	        if(item.response) {
	          this.modal.appealExtend.push(this.uploaderDomain + '/' + item.response.key)
	          this.fileList.push({'url': this.uploaderDomain + '/' + item.response.key})
	        }else {
	          this.modal.appealExtend.push(item.url)
	          this.fileList.push({'url': item.url})
	        }
	      })
	    },
	    //获取文件后缀名
	    getSuffix(file) { 
	      var lastPlace = file.lastIndexOf("."),
	          fileLength = file.length;
	      return file.substring(lastPlace + 1, fileLength)    
	    },
	    //获取上传七牛token
	    getToken(file) {
	      return this.$http.post(API_ROOT.method + '/qiniu/token', {ext: this.getSuffix(file.name)}).then((res) => {
	        var res = res.data
	        if( res.success ) {
	          this.token = {
	            key: res.data.key,
	            token: res.data.token
	          }
	          this.uploaderDomain = res.data.domain
	        } else {
	          this.$alert('上传图片失败!', '警告')
	        }
	      },(err) => {
	        this.$alert('上传图片失败!', '警告')
	      })
	    },
	    //上传七牛成功执行回调函数
	    uploadSuccess (response, file, fileList) {
	      var uploadUrl = this.uploaderDomain + '/' + response.key
	      this.modal.appealExtend.push(uploadUrl)
	    },
	    //弹出层关闭-查看详情
	    handleCloseResult() {
	    	this.result = {}
	    	this.dialogVisibleResult = false
	    },
	    //弹出层显示-查看详情
	    showResultModal(punishId) {
	    	this.$http.post(API_ROOT.method + '/appeal/getTjkAppealRecord', {'punishId': punishId}).then(response => {
	        var result = response.data
	        if(result.success) {
						this.result = result.data
						this.dialogVisibleResult = true
	        }else {
	          this.$alert(result.msg)
	        }
	      }, response => {
	        this.$alert('网络繁忙，请稍后重试！')
	      })
	    },
	    jumpToInfo(row) { // 详情跳转
        window.parent.location.href = '/customer/action/qualityControl/customerWeigui?id='+row.thirdPlatformId+'&customScore='+row.customScore
      }
		}
	}
</script>

<style lang="less" scoped="">
	.content-wrap {
		padding: 20px;
	}
	.link-text {
		display: inline-block;
    margin: 5px;
    cursor: pointer;
    color: #4297ff;
	}
	.form-img {
		width: 180px;
		float: left;
		margin-right: 10px;
	}
</style>


// WEBPACK FOOTER //
// ./src/page/blacklist.vue